
import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem, InputLabel, Grid } from '@mui/material'
import { useSelector } from 'react-redux';
import { selectErrorMessagesByKeyName } from '../../../../reducers/reference_errormessages';
import InputAnswer from './Input'


const Height = (props) => {
    const error_height_high = useSelector(state => { selectErrorMessagesByKeyName(state, 'VAL HEIGHT TOO HIGH') })
    const error_height_low = useSelector(state => { selectErrorMessagesByKeyName(state, 'VAL HEIGHT TOO LOW') })
    const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const uom = (settings?.SessionVariableValues && settings?.SessionVariableValues["QUESTION UOM TEMPLATE"]) || "1743"

    const [heightState, setHeightState] = useState({
        invalidAnswer: true, //on ComponenetDidMount, put logic in to update htis based on response
        answer: parseInt(props.question.Responses[0].Response),
        answerInches: parseInt(props.question.Responses[0].Response) % 12,
        answerFeet: Math.floor(parseInt(props.question.Responses[0].Response) / 12),
        valMin: parseInt(props.question.ValueLimitationMin),
        valMax: parseInt(props.question.ValueLimitationMax),
        valPrecision: parseInt(props.question.ValueLimitationPrecision),
        errorMessage: "",
        inputError: false,
        Inches: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        Feet: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    })
    //UNIT OF MEASURE METRIC
    const [response, setResponse] = useState(props.question.Responses[0].Response)

    useEffect(() => {
        createFeetArray()
    }, [])


    const createFeetArray = () => {
        let max = Math.floor(heightState.valMax / 12)
        let min = Math.floor(heightState.valMin / 12)

        let feet = []

        for (var x = min; x < max + 1; x++) {
            feet.push(x)
        }

        setHeightState({
            ...heightState,
            Feet: feet
        })


    }

    useEffect(() => {
        if (heightState.answerFeet > 0
            && heightState.answerInches >= 0
            && (heightState.answerFeet != Math.floor(parseInt(props.question.Responses[0].Response) / 12)
                || heightState.answerInches != parseInt(props.question.Responses[0].Response) % 12)) {
            setSavableAnswer()
        }
    }, [heightState.answerInches, heightState.answerFeet])

    const setInchesAndFeet = (answer) => {
        var feet = Math.floor(answer / 12)
        var inches = answer % 12

        setHeightState({
            ...heightState,
            answerInches: inches,
            answerFeet: feet
        })

    }

    const setInches = ev => {

        setHeightState({
            ...heightState,
            answerInches: ev.target.value
        }, () => {
            if (heightState.answerFeet >= 0 && heightState.answerInches >= 0) {
                setSavableAnswer()
            }
        })
    }

    const setFeet = (ev) => {
        setHeightState({
            ...heightState,
            answerFeet: ev.target.value
        }, () => {
            if (heightState.answerFeet >= 0 && heightState.answerInches >= 0) {
                setSavableAnswer()
            }
        }
        )
    }

    const setSavableAnswer = () => {
        var inches = heightState.answerInches + heightState.answerFeet * 12
        //console.log(inches)
        if (inches > heightState.valMax || inches < heightState.valMin) {
            setHeightState({
                ...heightState,
                errorMessage: inches > heightState.valMax ? error_height_high : inches < heightState.valMin ? error_height_low : "Height out of range",
                invalidAnswer: true
            })
        } else {
            if (inches > 0) {
                var inchString = inches.toString()
                props.saveAnswer(inchString, props.QuestionId)
            }
        }
    }

    if (props && uom!=='1743') {
        return (
            <InputAnswer {...props}/>
        )
    }
    else if(props) {

    
        let answer = props.question.Responses[0].Response;

        return (
            //<Radio>Answer</Radio>
            <Grid container xs={12}>
                <FormControl variant="outlined" style={{
                    minWidth: '100px',
                    margin: '10px',
                    padding: '10px'
                }}>
                    <InputLabel htmlFor="feet-select" id='feet-label'>{viewInstance?.SurveyPage?.OtherLabels?.FeetLabel || "Feet"} </InputLabel>
                    <Select
                        id="feet-select"
                        labelId="feet-label"
                        value={heightState.answerFeet}
                        onChange={setFeet}
                        label="Feet"
                        aria-labelledby="feet-label"
                        aria-invalid={heightState.errorMessage.length}
                    >
                        {heightState.Feet.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl variant="outlined" style={{
                    minWidth: '100px',
                    margin: '10px',
                    padding: '10px'
                }}>
                    <InputLabel htmlFor="inches-select" id="select-outlined-label">{viewInstance?.SurveyPage?.OtherLabels?.InchesLabel || "Inches"} </InputLabel>
                    <Select
                        labelId="select-outlined-label"
                        id="select-outlined"
                        value={heightState.answerInches}
                        onChange={setInches}
                        label="Inches"
                        aria-labelledby="inches-label"
                        aria-invalid={heightState.errorMessage.length}
                    >
                        {heightState.Inches.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                    </Select>
                </FormControl>
                <p style={{ color: "red" }}>{heightState.errorMessage}</p>
            </Grid>

        )
    }
}

export default Height;